import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const NotFound = () => {
    return (
        <div className="flex flex-1 flex-col md:flex-row items-center justify-center h-screen">
            <img
                src="/images/not-found.svg"
                alt="404 illustration"
                className="w-[25%]"
            />
            <div className="text-center md:text-left">
                <h2 className="text-2xl font-semibold mb-2">Page not found</h2>
                <p className="text-gray-400 mb-6 max-w-md font-['Archivo']">
                    Sorry, we couldn't find the page you're looking for.
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 rounded-md bg-white text-gray-900 hover:bg-gray-200 transition font-['Archivo']"
                >
                    <button className="flex items-center px-5 py-3 bg-[rgb(71,63,125)] text-white rounded-[4px]">
                        <FaArrowLeft className="mr-2"/>
                        Go Home
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
